import React from "react";
import MCSControlSelect from "../../../components/MCSControlSelect";

const VmidFlagSelect = (props) => {
  return (
    <MCSControlSelect
      name={props.name}
      control={props.control}
      rules={props.rules}
      label={props.label}
      handleChange={props.handleChange}
      options={
        <>
          <option value="" disabled hidden>
            - Select -
          </option>
          {props.options &&
            props.options.map((item, k) => (
              <option key={item.value.toString()} value={item.value}>
                {item.name}
              </option>
            ))}
        </>
      }
    />
  );
};
export default VmidFlagSelect;
